import LegalPage from "./LegalPage";

const DPA = () => <LegalPage docKey="dpa" />;

export default DPA;
